import { Link } from '@pinpointhq/thumbtack';
import * as React from 'react';

export interface IShownValue {
  canMask: boolean;
  isMasked?: boolean;
  defaultValue?: string;
  isLink?: boolean;
  linkValue?: string;
  value?: string;
}
export function shownValue({
  canMask,
  defaultValue = null,
  value = null,
  isMasked = true,
  isLink = false,
  linkValue,
}: IShownValue) {
  if (canMask && isMasked && defaultValue) {
    return '*'.repeat(defaultValue.length);
  }

  if (value && isLink) {
    return (
      <Link href={linkValue || value} target="_blank">
        {value}
      </Link>
    );
  }

  if (value) {
    return value;
  }

  return <span style={{ opacity: 0.5 }}>No value set</span>;
}
